export default {"src":"/_next/static/media/share-icon.4d682e02.svg","height":513,"width":513};